<template>
  <div
    v-if="loading"
    data-cy="onboarding-redirect-loading"
    class="flex h-screen items-center justify-center"
    role="status"
  >
    <LoaderCircle
      class="animate-spin"
      :size="100"
      aria-hidden="true"
    />
    <span class="sr-only">Loading...</span>
  </div>
</template>

<script setup lang="ts">
  import { LoaderCircle } from 'lucide-vue-next'
  import { genericErrorToast } from '@/lib/toasts'
  import { computed, onMounted, ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { CLIENT_PORTAL } from '@/router/routes'
  import { OnboardingSessionsService } from '@/types/generated'

  const route = useRoute()
  const router = useRouter()

  const packageUuid = computed(() => route.params.package_uuid as string)
  const loading = ref(true)

  // Determine source based on query parameter
  const source = computed(() => {
    return route.query.qr === 'true' ? 'qr_code' : 'link'
  })

  onMounted(async () => {
    try {
      const response = await OnboardingSessionsService.onboardingSessionsCreateFromPackageCreate({
        requestBody: {
          package_uuid: packageUuid.value,
          source: source.value
        }
      })

      if (response?.session_token) {
        await router.push({
          path: CLIENT_PORTAL.HOME,
          query: { session_token: response.session_token }
        })
      } else {
        genericErrorToast()
      }
    } catch (error) {
      console.error('Error creating onboarding session:', error)
      genericErrorToast()
    } finally {
      loading.value = false
    }
  })
</script>
